import { combineReducers } from 'redux'
import content from './get-all-content'
import geolocations from './get-all-geolocations'
import customers from './get-all-customers'
import responsibles from './get-all-responsibles'
import users from './get-all-users'

const reducer = combineReducers({
  content,
  geolocations,
  customers,
  users,
  responsibles
})

export default reducer
